import React from 'react';
import { Flex, Image, Stack, Text } from '@mantine/core';
import FailedIcon from '../../assets/icon/illustrations_error_cloudy.svg';
import Button from '../../components/elements/Button';
import { HiOutlineRefresh } from 'react-icons/hi';

interface FailedChartProps {
  icon?: any;
  message?: string;
  onLoad?: () => void;
}

const FailedChart: React.FC<FailedChartProps> = ({
  message = 'Failed to load data',
  icon = FailedIcon,
  onLoad
}) => {
  return (
    <Stack gap={16} flex={1} justify="center" align="center" h={'100%'}>
      <Image src={icon} w={250} alt="Failed to load chart" />
      <Stack align="center">
        <Text fw={700} fz={14} style={{ textAlign: 'center' }}>
          {message}
        </Text>

        {onLoad && (
          <Button full onClick={onLoad} variant="soft">
            <Flex justify={'center'} align={'center'} gap={8} flex={1}>
              <HiOutlineRefresh />
              Reload
            </Flex>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default FailedChart;
